<!-- Desktop view -->
<div class="desktop-sidebar">
  <div class="logo-and-links-container">
    <a routerLink="/dashboard" class="logo"></a>
    <div class="nav-links-container">
      <ng-container *ngIf="!onlyAdmin">
        <a class="link nav-link" routerLink="/dashboard" routerLinkActive="nav-link_active">
          <img class="themified-white-icon nav-link__icon" src="/assets/icons/dashboard-icon.png">
          <span class="nav-link__label">{{ 'sidebar.title.dashboard' | translate }}</span>
        </a>
        <a class="link nav-link" routerLink="/customers" routerLinkActive="nav-link_active">
          <img class="themified-white-icon nav-link__icon" src="/assets/icons/customer-list-icon.png">
          <span class="nav-link__label">{{ 'sidebar.title.customer_list' | translate }}</span>
        </a>
        <a class="link nav-link" routerLink="/own-restricted-list" routerLinkActive="nav-link_active">
          <img class="themified-white-icon nav-link__icon" src="/assets/icons/own-restricted-list-icon.png">
          <span class="nav-link__label">{{ 'sidebar.title.own_restricted_list' | translate }}</span>
        </a>
        <a class="link nav-link" routerLink="/expiring-documents" routerLinkActive="nav-link_active">
          <img class="themified-white-icon nav-link__icon" src="/assets/icons/expiring-documents-icon.png">
          <span class="nav-link__label">{{ 'sidebar.title.expiring_documents' | translate }}</span>
        </a>
        <a class="link nav-link" routerLink="/quick-scan" routerLinkActive="nav-link_active">
          <img class="themified-white-icon nav-link__icon" src="/assets/icons/past-records-icon.png">
          <span class="nav-link__label">{{ 'sidebar.title.quick_scan' | translate }}</span>
        </a>
        <a class="link nav-link" routerLink="/ongoing-due-diligence" routerLinkActive="nav-link_active">
          <img class="themified-white-icon nav-link__icon" src="/assets/icons/ongoing-due-diligence-icon.png">
          <span class="nav-link__label">{{ 'sidebar.title.ongoing-due-diligence' | translate }}</span>
        </a>
        <a class="link nav-link" routerLink="/periodic-review" routerLinkActive="nav-link_active">
          <img class="themified-white-icon nav-link__icon" src="/assets/icons/periodic-review-icon.png">
          <span class="nav-link__label">{{ 'sidebar.title.periodic_review' | translate }}</span>
        </a>
      </ng-container>
      <a class="link nav-link" routerLink="/admin" routerLinkActive="nav-link_active" *ngIf="hasAdmin">
        <img class="themified-white-icon nav-link__icon" src="/assets/icons/administration-icon.png">
        <span class="nav-link__label">{{ 'sidebar.title.admin' | translate }}</span>
      </a>
    </div>
  </div>
  <div class="new-customer-btn-container" *ngIf="!onlyAdmin">
    <button mat-button class="btn btn_blue-gradient-rounded new-customer-btn" ubi-round-button
            [artemisDropdownToggler]="userOnboardingMenu1" #artemisDropdown="dropdownToggler">
      {{ 'sidebar.title.new_customer' | translate }}
    </button>
    <artemis-dropdown-menu #userOnboardingMenu1 class="new-customer-dropdown">
      <a class="new-customer-dropdown__item" dropdown-item routerLink="/customers/onboarding" title="Manual customer input">
        {{ 'customer.title.manual_input' | translate }}
      </a>
      <a class="new-customer-dropdown__item" dropdown-item routerLink="/customers/batch-upload" title="Upload file with customers">
        {{ 'customer.title.batch_upload' | translate }}
      </a>
      <a class="new-customer-dropdown__item" dropdown-item routerLink="/handshakes" title="Purchase Bizfile From Handshakes" [ngClass]="{'dropdown-item_disabled': !enableHandshakes}">
        {{ 'customer.title.purchase_bizfile_from_handshakes' | translate }}
      </a>
      <a class="new-customer-dropdown__item" dropdown-item routerLink="/opencorporates" title="Import From OpenCorporates" [ngClass]="{'dropdown-item_disabled': !enableOpenCorporates}">
        {{ 'customer.title.import_from_opencorporates' | translate }}
      </a>
    </artemis-dropdown-menu>
  </div>
</div>
<!-- End Desktop view -->
<!-- Mobile view -->
<div class="mobile-sidebar" *ngIf="sidebarOpened" @fadeInOutMobileSidebar>
  <div class="mobile-sidebar__background" (click)="toggleSidebar()" @fadeInOutMobileSidebarBackground></div>
  <div class="mobile-sidebar__content" @fadeInOutMobileSidebarContent>
    <img class="themified-white-icon mobile-sidebar__close-icon" src="/assets/icons/cross-icon.png" (click)="toggleSidebar()"/>
    <!-- User info block -->
    <div class="user-info">
      <!-- User info top bar -->
      <div class="user-info__row user-info__top-bar">
        <img class="themified-white-icon user-info__profile-icon" src="/assets/icons/user-profile-icon.png"/>
        <span class="user-info__profile-name" [title]="(profileStore$ | async)?.user?.name">{{(profileStore$ | async)?.user?.name}}</span>
        <div class="user-info__menu-trigger-container" [artemisDropdownToggler]="pagesDropdownMenu">
          <img class="themified-white-icon user-info__menu-trigger-icon" src="/assets/icons/chevron-down-icon.png"/>
        </div>
        <artemis-dropdown-menu class="dropdown_after-line" #pagesDropdownMenu (click)="toggleSidebar()">
          <a class="user-info__dropdown-items" dropdown-item routerLink="/account-settings" title="Profile settings">{{ 'dropdown.title.account_settings' | translate }}</a>
          <a class="user-info__dropdown-items" dropdown-item routerLink="/user-guide" title="User Guide">{{ 'dropdown.title.user_guide' | translate }}</a>
          <a class="user-info__dropdown-items" dropdown-item title="Log out" (click)="logOut()">{{ 'dropdown.title.log_out' | translate }}</a>
        </artemis-dropdown-menu>
      </div>
      <!-- End User info top bar -->
      <!-- User info middle bar -->
      <div class="user-info__row">
        <div class="user-info__theme-toggler">
          <img class="user-info__theme-toggler-icon" [src]="isCurrentThemeLight ? '/assets/icons/dark-theme-icon.svg' : '/assets/icons/dark-theme-on-icon.svg'" title="Light Theme"/>
          <mat-slide-toggle class="custom-mat-slide-toggle theme-toggle" artemisThemeSwitcher
                            [checked]="isCurrentThemeLight" (change)="themeChanged()"></mat-slide-toggle>
          <img class="user-info__theme-toggler-icon" [src]="isCurrentThemeLight ? '/assets/icons/light-theme-on-icon.svg' : '/assets/icons/light-theme-icon.svg'" title="Dark Theme"/>
        </div>

        <div class="user-info__admin-list" [title]="roles">
          {{roles}}
        </div>
      </div>
      <!-- End User info middle bar -->
      <!-- User info bottom bar -->
      <div class="user-info__row user-info__domain">
        <div class="user-info__domain-name" [title]="(currentDomainStore$ | async)?.domainName">
          {{(currentDomainStore$ | async)?.domainName}}
        </div>
        <img class="themified-white-icon user-info__domain-toggler" src="/assets/icons/switch-icon.png" title="Change Business Unit" (click)="selectDomain()"/>
      </div>
      <!-- End User info bottom bar -->
    </div>
    <!-- End User info block -->
    <!-- Nav links block -->
    <div class="nav-links-container">
      <ng-container *ngIf="!onlyAdmin">
        <a class="link nav-link" routerLink="/dashboard" routerLinkActive="nav-link_active" (click)="toggleSidebar()">
          <div class="nav-link__icon-container">
            <img class="themified-white-icon nav-link__icon" src="/assets/icons/dashboard-icon.png">
          </div>
          <span class="nav-link__label">{{ 'sidebar.title.dashboard' | translate }}</span>
        </a>
        <a class="link nav-link" [artemisDropdownToggler]="userOnboardingMenu">
          <div class="nav-link__icon-container">
            <img class="themified-white-icon nav-link__icon" src="/assets/icons/plus-icon-white.png">
          </div>
          <span class="nav-link__label">{{ 'sidebar.title.add_customer' | translate }}</span>
          <artemis-dropdown-menu #userOnboardingMenu>
            <a class="user-info__dropdown-items" dropdown-item routerLink="/customers/onboarding" title="Manual customer input"
               (click)="toggleSidebar()">
               {{ 'customer.title.manual_input' | translate }}
            </a>
            <a class="user-info__dropdown-items" dropdown-item routerLink="/customers/batch-upload" title="Upload file with customers"
               (click)="toggleSidebar()">
               {{ 'customer.title.batch_upload' | translate }}
            </a>
            <a class="user-info__dropdown-items" dropdown-item routerLink="/handshakes" title="Purchase Bizfile From Handshakes"
               (click)="toggleSidebar()" [ngClass]="{'dropdown-item_disabled': !enableHandshakes}">
               {{ 'customer.title.purchase_bizfile_from_handshakes' | translate }}
            </a>
            <a class="user-info__dropdown-items" dropdown-item routerLink="/opencorporates" title="Import From OpenCorporates" (click)="toggleSidebar()" [ngClass]="{'dropdown-item_disabled': !enableOpenCorporates}">
              {{ 'customer.title.import_from_opencorporates' | translate }}
            </a>
          </artemis-dropdown-menu>
        </a>
        <a class="link nav-link" routerLink="/customers" routerLinkActive="nav-link_active" (click)="toggleSidebar()">
          <div class="nav-link__icon-container">
            <img class="themified-white-icon nav-link__icon" src="/assets/icons/customer-list-icon.png">
          </div>
          <span class="nav-link__label">{{ 'sidebar.title.customer_list' | translate }}</span>
        </a>
        <a class="link nav-link" routerLink="/own-restricted-list" routerLinkActive="nav-link_active" (click)="toggleSidebar()">
          <div class="nav-link__icon-container">
            <img class="themified-white-icon nav-link__icon" src="/assets/icons/own-restricted-list-icon.png">
          </div>
          <span class="nav-link__label">{{ 'sidebar.title.own_restricted_list' | translate }}</span>
        </a>
        <a class="link nav-link" routerLink="/expiring-documents" routerLinkActive="nav-link_active" (click)="toggleSidebar()">
          <div class="nav-link__icon-container">
            <img class="themified-white-icon nav-link__icon" src="/assets/icons/expiring-documents-icon.png">
          </div>
          <span class="nav-link__label">{{ 'sidebar.title.expiring_documents' | translate }}</span>
        </a>
        <a class="link nav-link" routerLink="/quick-scan" routerLinkActive="nav-link_active" (click)="toggleSidebar()">
          <div class="nav-link__icon-container">
            <img class="themified-white-icon nav-link__icon" src="/assets/icons/past-records-icon.png">
          </div>
          <span class="nav-link__label">{{ 'sidebar.title.quick_scan' | translate }}</span>
        </a>
        <a class="link nav-link" routerLink="/ongoing-due-diligence" routerLinkActive="nav-link_active" (click)="toggleSidebar()">
          <div class="nav-link__icon-container">
            <img class="themified-white-icon nav-link__icon" src="/assets/icons/ongoing-due-diligence-icon.png">
          </div>
          <span class="nav-link__label">{{ 'sidebar.title.ongoing-due-diligence' | translate }}</span>
        </a>
        <a class="link nav-link" routerLink="/periodic-review" routerLinkActive="nav-link_active" (click)="toggleSidebar()">
          <div class="nav-link__icon-container">
            <img class="themified-white-icon nav-link__icon" src="/assets/icons/periodic-review-icon.png">
          </div>
          <span class="nav-link__label">{{ 'sidebar.title.periodic_review' | translate }}</span>
        </a>
      </ng-container>
      <a class="link nav-link" routerLink="/admin" routerLinkActive="nav-link_active" (click)="toggleSidebar()" *ngIf="hasAdmin">
        <div class="nav-link__icon-container">
          <img class="themified-white-icon nav-link__icon" src="/assets/icons/administration-icon.png">
        </div>
        <span class="nav-link__label">{{ 'sidebar.title.admin' | translate }}</span>
      </a>
    </div>
    <!-- End Nav links block -->
    <div class="copyright">
      <span>{{ 'footer.copyright' | translate }}</span>
      <span>{{ 'footer.all_right' | translate }}</span>
    </div>
  </div>
</div>
<!-- End Mobile view -->
